import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import VagonStreamIntraverse from "./VagonStreamIntraverse";
import { isMobileDevice } from "../../utils/generalUtils";
import AvatarPageRegularUser from "../../pages/presets/AvatarPageRegularUser";
import { UpdateRoomInviteUserData } from "../../api/RoomsController";
import AvatarPresetPage from "../../pages/presets/AvatarPresetPage";

export default function DefaultStream({ userId, token, spotifyPlayer, roomId }) {
    const [streamUrl, setStreamUrl] = useState(null);
    const [selectedAvatar, setSelectedAvatar] = useState(sessionStorage.getItem("selectedAvatar") || "");
    const isRoomInvite = localStorage.getItem("inviteRoomId");
    const inviteSettings = localStorage.getItem("inviteSettings");

    useEffect(() => {
        let timeoutId;

        const updateInviteData = async () => {
            if (streamUrl && isRoomInvite !== null && inviteSettings !== null) {
                const THREE_MINUTES_MS = 3 * 60 * 1000;
                timeoutId = setTimeout(async () => {
                    const resp = await UpdateRoomInviteUserData(isRoomInvite, userId, inviteSettings, "login");
                    if (resp.status === 200) {
                        localStorage.removeItem("inviteRoomId");
                        localStorage.removeItem("inviteSettings");
                    }
                }, THREE_MINUTES_MS);
            }
        };

        updateInviteData();

        // Cleanup in case component unmounts before timeout fires
        return () => clearTimeout(timeoutId);
    }, [streamUrl, isRoomInvite, inviteSettings, userId]);

    const launchFlags = useMemo(() => {
        const flags = {
            "-userid": userId,
            "-authtoken": token,
            "-api": process.env.REACT_APP_STREAM_API_ENV,
            "-disableVoiceChat": false,
            "-showdebugger": true,
            "-userdevicetype": isMobileDevice() ? "mobile" : "desktop",
            "-avatarpreset": selectedAvatar,
            "-url": window.location.href,
            "-disablecameramouserotation": true,
        };

        // Add clientTag from localStorage if present (pattern from vanity link)
        const vanityLinkInfo = JSON.parse(localStorage.getItem("vanityLinkInfo") || "{}");
        if (vanityLinkInfo && vanityLinkInfo.clientTag) {
            flags["-clienttag"] = vanityLinkInfo.clientTag;
        }

        if (isRoomInvite !== null && inviteSettings !== null) {
            flags["-roomid"] = isRoomInvite;
            flags["-invitesettings"] = inviteSettings;
        } else if (roomId) {
            // Use the roomId from vanity linkout retry
            flags["-roomid"] = roomId;
        }

        return flags;
    }, [userId, token, selectedAvatar, isRoomInvite, inviteSettings, roomId]);

    useEffect(() => {
        const base = process.env.REACT_APP_DEFAULT_STREAM_URL;
        const qs = Object.entries(launchFlags)
            .map(([k, v]) => `${encodeURIComponent(k)}%20${encodeURIComponent(v)}`)
            .join("%20");
        setStreamUrl(`${base}?launchFlags=${qs}`);
    }, [launchFlags]);

    // If no avatar exists or is selected, render the AvatarPresetPage
    if (!selectedAvatar) {
        return (
            <AvatarPresetPage
                setSelectedAvatar={setSelectedAvatar}
                forceLandScape
                userToken={token}
                userId={userId}
            />
        );
    }

    if (!streamUrl) return null;
    return <VagonStreamIntraverse streamUrl={streamUrl} spotifyPlayer={spotifyPlayer} />;
}

DefaultStream.propTypes = {
    userId: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    spotifyPlayer: PropTypes.object,
    roomId: PropTypes.string,
};
